import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormHelperText from '@mui/material/FormHelperText'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Input from '@mui/material/Input'
import TextCurriculum from '../../text/TextCurriculum'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip, Typography } from '@mui/material'

/* 	InputField 
 *	@params id 			string	 	identificador input
 * 	@params label 		string  	label input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params error		bool 		enable class error
 *	@params helperText	string 		helper text 
 *	@params onChange	function 	function change		
 *	@params InputProps	Object
 *	More Information https://material-ui.com/es/api/text-field/ 		
*/

const SelectMultipleField = ({ id, label, caret, name, placeholder, onClear, loading, value = [], error, disabled, helperText, onChange, chip, options, onBlur, displayEmpty = true }) => {
  const [open, setOpen] = React.useState(false)

  const handleChange = (e) => {
    if (onChange) {
      onChange(e)
    }
    if (e.target.value.some((x) => x === 'all')) {
      handleClose()
    }
  };

  const handleClose = () => {
    setOpen(false)
  };

  const handleOpen = () => {
    setOpen(true)
  };

  return (
    <FormControl variant="standard" fullWidth error={!!error}>
      { label && 
        <InputLabel shrink>
          { caret && <TextCurriculum  className="text-x-medium"  label={label} /> }
          { !caret && <>{label}</> }
        </InputLabel> 
      }
      <Select
        variant="standard"
        fullWidth
        id={id}
        value={value ? value : []}
        name={name}
        multiple
        error={!!error}
        disabled={disabled || loading}
        onChange={handleChange}
        onBlur={onBlur}
        displayEmpty={displayEmpty}
        input={<Input 
          endAdornment={
            <React.Fragment>
              <div className='m-r-20'>
                {onClear ? <FontAwesomeIcon className="text-grey-dark text-clickeable" onClick={onClear} icon={['fal', 'times']} /> : null}
                {loading ? <FontAwesomeIcon className="text-grey-dark" icon='circle-notch' spin /> : null}
              </div>
            </React.Fragment>
          }    
        />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span className="opacity-50">{placeholder}</span>
          }
          
          const values =  selected?.map((x) => {
            const find = options.find((op) => op.value === x)
            if (find) {
              return find.label
            } else {
              return x
            }
          })

          if (chip) {
            return (<div className='flex items-center justify-start'>
              {values.map((value) => (<Chip size='small' className='m-r-5' key={value} label={value}  />))}
            </div>)
          } else {
            return values.join(', ');
          }
        }}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}>
        {placeholder && 
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
        }
        {
          options.map((op, i) => (
          <MenuItem 
            key={`${id}-${i}`}
            value={op.value}
            disabled={op.disabled}
          >
            {value?.includes(op.value) ? <FontAwesomeIcon className="text-primary" icon='check' /> : <div className='px-2' />}
            <Typography variant='inherit' component='span' className='pl-2'>
              {op.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
      { helperText && 
          <FormHelperText error={!!error}>
              { caret && <TextCurriculum  className="text-x-medium" label={helperText} /> }
              { !caret && <>{helperText}</> }
          </FormHelperText>
      }         
    </FormControl>
  );
}

export default SelectMultipleField